<template>
  <Modal
    v-if="showModal"
    :title="isEditMode ? 'Edit Table Widget' : 'Create Table Widget'"
    :okButtonLabel="isEditMode ? 'Save' : 'Create'"
    :cancelButtonLabel="'Cancel'"
    :modalStyles="{ width: '600px' }"
    :disabled="disableOkButton"
    :isSaving="isSaving"
    :okFunction="isEditMode ? updateTableWidget : createTableWidget"
    :avoidClickOutside="isEditMode"
    @closeModal="closeModal"
  >
    <template #body>
      <div v-if="!isEditMode" class="form-group">
        <label class="label" for="widgetName">
          <div>Widget Name</div>
          <input
            type="text"
            name="widgetName"
            id="widgetName"
            required
            v-model="name"
            placeholder="Set widget's name"
            maxlength="40"
          />
        </label>
      </div>

      <div class="label">Table Content</div>
      <div class="table-modal-content">
        <TableContent :rows="tableData.rows" :columns="tableData.columns" />
      </div>
    </template>
  </Modal>
</template>

<script>
  import TableContent from '@/components/apps/table/TableContent.vue';
  import Modal from '@/components/common/Modal.vue';

  export default {
    name: 'TableWidgetModal',

    components: {
      TableContent,
      Modal,
    },

    props: {
      isEditMode: {
        type: Boolean,
        default: false,
      },
      tableData: {
        type: Object,
        default: () => ({
          columns: 2,
          rows: [
            {
              type: 'heading',
              data: [
                {
                  content: 'Col 1',
                },
                {
                  content: 'Col 2',
                },
              ],
            },
            {
              type: 'body',
              data: [
                {
                  content: '',
                },
                {
                  content: '',
                },
              ],
            },
          ],
        }),
      },
    },

    data() {
      return {
        showModal: false,
        isSaving: false,
        name: 'Table Widget',
        rows: [],
      };
    },

    mounted() {
      this.showModal = true;

      if (this.isEditMode) {
        this.rows = JSON.parse(JSON.stringify(this.tableData.rows));
      }
    },

    computed: {
      disableOkButton() {
        return !this.tableData.rows || this.tableData.rows.length === 0;
      },
    },

    methods: {
      closeModal() {
        if (this.isEditMode) {
          this.$set(this.tableData, 'rows', this.rows);
        }

        this.showModal = false;
        this.$emit('closeModal');
      },

      createTableWidget() {
        try {
          this.isSaving = true;
          this.$emit('createTableWidget', {
            name: this.name,
            columns: this.tableData.columns,
            rows: JSON.parse(JSON.stringify(this.tableData.rows)),
          });

          this.isSaving = false;
          this.showModal = false;
        } catch (error) {
          this.isSaving = false;
          this.$toasted?.global?.general_error({
            message: 'Error creating table widget',
          });
        }
      },

      updateTableWidget() {
        this.showModal = false;
        this.$emit('closeModal');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .table-modal-content {
    padding: 16px 16px 0;
    max-height: min(800px, 100vh - 200px);
    width: 100%;
  }

  .form-group {
    width: 320px;
    margin-bottom: 20px;

    label {
      display: flex;
      flex-direction: column;
      margin-bottom: 0;
      gap: 8px;
      font-weight: 500;
      line-height: 24px;

      input {
        padding: 8px 16px;
        border: 2px solid $borderGrey;
        border-radius: 8px;
        font-size: 16px;
      }
    }
  }

  .label {
    font-weight: 500;
    line-height: 24px;
  }
</style>
